export const TABLE_CELL_VARIANTS = {
  MAIN: 'main',
  SECONDARY: 'secondary',
};

export const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50];
